<std-modal [show]="true" *transloco="let t" cardClass="!max-w-[90vw] min-w-[300px]" headerClass="bg-primary" [closeOnOutside]="false"
  (close)="autoDestory()">
  <div header class="text-tertiary">Crea azienda</div>
  <div content>
    <std-select [currentValue]="fatherElement ? {value:fatherElement.day,label:t('daysOfTheWeek.'+fatherElement.day)} : null" (onChangeValue)="changeDay($event)" labelPosition="top" label="Giorno" direction="down" [data]='[
            {
              label: "Lunedi",
              value: 1,
            },
            {
              label: "Martedi",
              value: 2,
            },
            {
              label: "Mercoledi",
              value: 3,
            },
            {
              label: "Giovedi",
              value: 4,
            },
            {
              label: "Venerdi",
              value: 5,
            },
            {
              label: "Sabato",
              value: 6,
            },
            {
              label: "Domenica",
              value: 0,
            },
          ]'></std-select>
          <div class="font-semibold text-[24px] mt-2.5">Orario apertura</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="myDay.timeStart" (changeDate)="myDay.timeStart = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
        <div class="font-semibold text-[24px] mt-2.5">Orario chiusura</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="myDay.timeEnd" (changeDate)="myDay.timeEnd = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
    <div class="flex mt-5">
      <div>Aggiungi fascia alta</div>
      <div (click)="addHighRange()"
        class="text-white ml-auto bg-primary rounded-full cursor-pointer flex place-content-center items-center size-10 text-[20px]">+
      </div>
    </div>
    <div>
      @for (high of highRange; track $index) {
      <div class="border-[3px] border-black rounded-[20px] p-2 mt-2">
          <div (click)="removeHighRange($index)"
            class="text-white ml-auto bg-primary rounded-full cursor-pointer flex place-content-center items-center size-10 text-[20px]">
            -</div>
            @if(isChanging){
        <div class="font-semibold text-[24px]">Inizio</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="high.timeStart" (changeDate)="high.timeStart = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
        <div class="font-semibold text-[24px]">Fine</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="high.timeEnd" (changeDate)="high.timeEnd = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
      }@else{
        <div class="font-semibold text-[24px]">Inizio</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="high.timeStart" (changeDate)="high.timeStart = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
        <div class="font-semibold text-[24px]">Fine</div>
        <std-time-picker [stepMinutes]="30" [startingTime]="high.timeEnd" (changeDate)="high.timeEnd = $event.formattedTime + ':00'" [showClock]="false" customClassContainer="border-none p-0 mt-0 remove-mt" [use24h]="true"></std-time-picker>
      }
      </div>
      }
    </div>
    <div class="w-50% mt-4">
      <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" class="w-full"
        (click)="createTimetable()">Crea</std-button>
    </div>
  </div>
</std-modal>
<!-- 
@if(showSelectTime){
  <div class="flex h-screen w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[9999]">
            <std-time-picker [showClock]="false" [stepMinutes]="dataParams.stepMinutes" [use24h]="dataParams.use24h" [startingTime]="!isNewSubElement ? subElementModalValue[dataForm.element] : '00:00'" (changeDate)="tempVariable = $event.formattedTime">
              <div footer class="mt-6 flex gap-4">
               <div class="w-full"> <std-button
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="specialModalTimeToShow = ''"
                  class="w-[200px]"
                  >{{ t("modal.cancel") }}</std-button
                ></div>
              <div class="w-full">  <std-button [ngClass]="{'opacity-35 pointer-events-none':isNewSubElement && !tempVariable }"
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="subElementModalValue[dataForm.element] = tempVariable ? tempVariable : '00:00';tempVariable=null;specialModalTimeToShow = null"
                  class="w-[200px]"
                  >{{ t("modal.confirm") }}</std-button
                ></div>
              </div>
            </std-time-picker>
          </div>
} -->